
























helpers = require('../../helpers.coffee')

view_model =
  mixins: [require('../../mixins/users_options.coffee')]

  props: ['filters', 'options']

  data: ->
    sort_filter: @extractFilter('s')
    sort_options: [
      { value: null, text: this.$t('general.label.newest') }
      { value: {s: 'id asc'}, text: this.$t('general.label.oldest') }
    ],

    user_filter: @extractFilter('user_id_eq')
    users_options: [
      { value: null, text: this.$t('general.label.loading') }
    ]

    text_field_filter: @filters.name_cont

    show_user_filter: !Session.current_user.isSeller() || @options?.show_user_filter

  computed:
    filterParams: ->
      filter_params = {}
      for filter in [@sort_filter, @user_filter]
        Object.assign(filter_params, filter) if filter
      filter_params['name_cont'] = @text_field_filter if @text_field_filter
      filter_params

  methods:
    filter: ->
      @applyFiltersOnUrlQueryParams(@filterParams)
      @$emit('filter', @filterParams)

exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/filters.vue